import * as React from 'react';
import * as styles from './LayoutSection.css';

export const LayoutSection: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['layout-section']}>{children}</div>;
};
